import React from "react";
import ColorButton from "../common/ColorButton";
import TSTable from "../common/TSTable";
import { Layout, theme, Descriptions, Divider } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PATH } from "../routes/CustomRoutes";
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import { PRIMARY_COLOR } from "../constants/color";
import PurchaseAddInvoiceModal from "../components/purchase/PurchaseAddInvoiceModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";

export default function PurchaseDetailScreen() {
  const [ openAddInvoiceModal, setOpenAddInvoiceModal] = React.useState(false)
  const { token : { colorSuccess, colorPrimary, colorWarning } } = theme.useToken();
  const  navigate  = useNavigate();

  const mockUserData = [{

  }]

  const item = [
    {
      key: '1',
      label: 'หมายเลขรายการ',
    },
    {
      key: '2',
      label: 'ชื่อลูกค้า',
      span: 2,
    },
    {
      key: '3',
      label: 'วันที่',
    },
    {
      key: '4',
      label: 'สินค้า',
    },
    {
      key: '5',
      label: 'packing',
    },
  ]

  const columns = [
    {
      title : 'action',
      dataIndex : '',
      render : () => 
        <center>
          <ColorButton
            type="primary"
            override={colorPrimary}
            icon = {<FontAwesomeIcon icon={faTruck} />}
            style={{ marginRight : 10}}
            onClick={() => navigate(PATH.PURCHASE_SEND_PRODUCT)}
          />
          <ColorButton
            type="primary"
            override={colorWarning}
            icon = {<EditOutlined />}
            style={{ marginRight : 10}}
            onClick={() => {}}
          />
        </center>  
    },
    {
      title : 'หมายเลขตู้',
      dataIndex : 'no',
    },
    {
      title : 'หมายเลข Seal',
      dataIndex : 'seal_no',
    },
    {
      title : 'ทะเบียนรถ',
      dataIndex : 'licence',
    },
    {
      title : 'น้ำหนักขาย',
      dataIndex : 'weight',
    },
    {
      title : 'สถานะ',
      dataIndex : 'status',
    },
  ]


	return(
    <Layout>
      <HeaderScreen title={"รายการสั่งซื้อ - "}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        <Descriptions
          bordered
          column={3}
          size={"small"}
          items={item}
        />  
        <div style={{ color : PRIMARY_COLOR, fontSize : 18, marginTop : 15, marginLeft : 10}}>
          {"ใบส่งสินค้า"}
          <ColorButton 
            type={"primary"} 
            size={"medium"} 
            override={colorSuccess} 
            icon={<PlusCircleFilled/>} 
            style={{float : 'right', width : 100, marginRight : 10}}
            onClick={() => setOpenAddInvoiceModal(true)}
          >
            {"เพิ่ม"}
          </ColorButton>
        </div>
        <Divider style={{ marginTop : 20, marginBottom : 10}}/>
        <TSTable
          columns={columns}
          data={mockUserData}
          hidePagination={true}
        />
      </Content>

      <PurchaseAddInvoiceModal
        open={openAddInvoiceModal}
        onClose={() => setOpenAddInvoiceModal(false)}
      />
    </Layout>
)
}